/**
 * @generated SignedSource<<11653c62824280775ccc5476facdea8c>>
 * @relayHash d6be154debcc9cc4834278390fc53126
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2aa0ed74afe3b72eb6db76d715d8da108ed70a4d3568c05987cecb7b3770645b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type SpaceOverviewQuery$variables = {
  excludeOperations: boolean;
  spaceKey: string;
};
export type SpaceOverviewQuery$data = {
  readonly space: {
    readonly currentUser: {
      readonly isAdmin: boolean;
    };
    readonly homepage: {
      readonly id: string | null | undefined;
      readonly operations?: ReadonlyArray<{
        readonly operation: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly icon: {
      readonly path: string;
    } | null | undefined;
    readonly id: string | null | undefined;
    readonly name: string | null | undefined;
    readonly theme: {
      readonly themeKey: string | null | undefined;
    } | null | undefined;
    readonly type: string | null | undefined;
  } | null | undefined;
};
export type SpaceOverviewQuery = {
  response: SpaceOverviewQuery$data;
  variables: SpaceOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeOperations"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "concreteType": "SpaceUserMetadata",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isAdmin"
          }
        ]
      },
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "type"
      },
      {
        "concreteType": "Theme",
        "kind": "LinkedField",
        "name": "theme",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "themeKey"
          }
        ]
      },
      {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "path"
          }
        ]
      },
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "condition": "excludeOperations",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "concreteType": "OperationCheckResult",
                "kind": "LinkedField",
                "name": "operations",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "operation"
                  }
                ]
              }
            ]
          },
          {
            "args": [
              {
                "kind": "Literal",
                "name": "keys",
                "value": [
                  "emoji-title-published"
                ]
              }
            ],
            "concreteType": "PaginatedJsonContentPropertyList",
            "kind": "LinkedField",
            "name": "properties",
            "plural": false,
            "selections": [
              {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  }
                ]
              }
            ],
            "storageKey": "properties(keys:[\"emoji-title-published\"])"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SpaceOverviewQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SpaceOverviewQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "d6be154debcc9cc4834278390fc53126",
    "id": "2aa0ed74afe3b72eb6db76d715d8da108ed70a4d3568c05987cecb7b3770645b",
    "metadata": {},
    "name": "SpaceOverviewQuery",
    "operationKind": "query",
    "text": "query SpaceOverviewQuery($spaceKey:String!,$excludeOperations:Boolean!){space(key:$spaceKey){id,currentUser{isAdmin},name,type,theme{themeKey},icon{path},homepage{id,operations@skip(if:$excludeOperations){operation},properties(keys:[\"emoji-title-published\"]){nodes{id,key,value}}}}}"
  }
};
})();

(node as any).hash = "800c4a5e07b722b2b0e454947ac55f3c";

export default node;
